import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhom() {
  const isFor = ['Mujeres de 40 a 60 años que sienten que su metabolismo se ha detenido.', 'Personas que sufren de inflamación abdominal persistente ("barriga de estrés").', 'Aquellas que se sienten cansadas a pesar de dormir y frustradas por la falta de resultados.', 'Mujeres que buscan una solución basada en la ciencia hormonal, no en la privación.'];
  const notFor = ['Personas que buscan una "pastilla mágica" sin cambiar sus hábitos matutinos.', 'Quienes prefieren contar calorías de forma obsesiva en lugar de sanar su metabolismo.', 'Personas menores de 35 años que aún no han experimentado el cambio hormonal metabólico.'];
  return <section className="py-20 px-6 bg-cream" data-id="element-86">
      <div className="max-w-5xl mx-auto" data-id="element-87">
        <FadeIn data-id="element-88">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-89">
            {/* Para quién es */}
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-sage/20" data-id="element-90">
              <h3 className="font-serif text-2xl text-charcoal mb-6 flex items-center gap-3" data-id="element-91">
                <CheckCircle2 className="text-sage" size={28} data-id="element-92" />
                Para quién es
              </h3>
              <ul className="space-y-4" data-id="element-93">
                {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 font-sans text-charcoal/80 leading-relaxed" data-id="element-94">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-sage shrink-0" data-id="element-95" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Para quién NO es */}
            <div className="bg-white/50 p-8 rounded-3xl border border-charcoal/10" data-id="element-96">
              <h3 className="font-serif text-2xl text-charcoal/60 mb-6 flex items-center gap-3" data-id="element-97">
                <XCircle className="text-terracotta/60" size={28} data-id="element-98" />
                Para quién NO es
              </h3>
              <ul className="space-y-4" data-id="element-99">
                {notFor.map((item, idx) => <li key={idx} className="flex items-start gap-3 font-sans text-charcoal/60 leading-relaxed" data-id="element-100">
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-terracotta/40 shrink-0" data-id="element-101" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}